<template>
  <v-app>
    <v-container fluid class="pa-2">
      <v-form @submit.prevent="submitForm">
        <v-row>

          <!-- LEFT : DYEING MASTER -->
          <v-col cols="12" md="12">
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-header" color="blue-grey-lighten-4">
                  Proforma Invoice Info
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <v-row dense class="mt-3 px-2">

                    <v-col cols="12" md="3">
                      <v-autocomplete
                        label="Master Sales Contract"
                        v-model="master_sales_contact_id"
                        :items="masterSalesContactList"
                        item-title="code"
                        item-value="id"
                        :error-messages="errors.master_sales_contact_id"
                        density="compact"
                        variant="outlined"
                        clearable
                        @update:model-value="changeMsterSalesContact"
                      />
                    </v-col>
                    
                    <v-col cols="12" md="3">
                       <v-text-field autocomplete="on" label="Master Sales Contact No" v-model="master_sales_contact_no" :error-messages="errors.master_sales_contact_no" variant="outlined" density="compact" />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-date-input
                          input-format="dd/mm/yyyy"

                      prepend-icon="" 
                      label="Invoice Date*" 
                      v-model="invoice_date" 
                      :error-messages="errors.invoice_date" 
                      variant="outlined" 
                      density="compact"/>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field 
                      label="Proforma Invoice No*" 
                      v-model="proforma_invoice_no" 
                      :error-messages="errors.proforma_invoice_no" 
                      variant="outlined" 
                      autocomplete="on"
                      density="compact"/>
                    </v-col>

                    <v-col cols="12" md="3">
                       <v-text-field
                      autocomplete="on" 
                      label="Season" 
                      v-model="season"  
                      :error-messages="errors.season" 
                      variant="outlined" 
                      density="compact"/>
                    </v-col>

                    <v-col cols="12" md="3">
                       <v-text-field autocomplete="on" label="Department" v-model="department"  :error-messages="errors.department" variant="outlined" density="compact"/>
                    </v-col>

                    <v-col cols="12" md="3">
                       <v-text-field autocomplete="on" label="Purchase Order No" v-model="purchase_order_no" :error-messages="errors.purchase_order_no" variant="outlined" density="compact"/>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-autocomplete label="Buyer*"
                        v-model="buyer_id" :error-messages="errors.buyer_id" :items="buyerList" item-title="name" item-value="id" variant="outlined" density="compact" />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-autocomplete 
                      label="Beneficiary Bank*" 
                      v-model="beneficiary_bank_id" 
                      :error-messages="errors.beneficiary_bank_id" 
                      :items="bankList" 
                      item-title="name" 
                      item-value="id" 
                      variant="outlined" 
                      density="compact"/>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Currency*"
                        v-model="currency_id"
                        :items="currencyList"
                        :item-title="item => `${item.code} - ${item.name}`"
                        item-value="id"
                        :error-messages="errors.currency_id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <!-- <v-col cols="12" md="3">
                      <v-autocomplete 
                      label="Buyer Bank*"  
                      v-model="buyer_bank_id" 
                      :error-messages="errors.buyer_bank_id" 
                      :items="bankList" 
                      item-title="name" 
                      item-value="id" 
                      variant="outlined" 
                      density="compact"/>
                    </v-col> -->

                  <v-col cols="12" md="3">
                      <v-select
                        label="Shipment From"
                        v-model="shipment_from"
                        :items="portList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.shipment_from"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Shipment To"
                        v-model="shipment_to"
                        :items="portList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.shipment_to"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-autocomplete label="Shipment Mode*" v-model="shipment_mode_id" :error-messages="errors.shipment_mode_id" :items="shippingMethodList" item-title="name" item-value="id" variant="outlined" density="compact"/>
                    </v-col>

                    <v-col cols="12" md="3">
                       <v-text-field  autocomplete="on" label="Inspection Certificate By" v-model="inspaction_certificate_by" :error-messages="errors.inspaction_certificate_by" variant="outlined" density="compact"/>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-date-input
                         input-format="dd/mm/yyyy" prepend-icon="" label="LC Expiry Date*" v-model="lc_expiry_date" :error-messages="errors.lc_expiry_date" variant="outlined" density="compact"/>
                    </v-col>

                    <v-col cols="12" md="3">
                       <v-autocomplete label="Port of Loading*" v-model="port_of_loading_id" :error-messages="errors.port_of_loading_id" :items="portList" item-title="name" item-value="id" variant="outlined" density="compact"/>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-autocomplete label="Port of Destination*" v-model="port_of_destination_id" :error-messages="errors.port_of_destination_id" :items="portList" item-title="name" item-value="id" variant="outlined" density="compact"/>
                    </v-col>

                    <v-col cols="12" md="3">
                       <v-text-field  autocomplete="on" label="Incoterm" v-model="incoterm" :error-messages="errors.incoterm" variant="outlined" density="compact"/>
                    </v-col>

                    <v-col cols="12" md="3">
                       <v-text-field  autocomplete="on" type="number" label="Short / Excess Shipment %" v-model="short_or_excess_shipment_percent" :error-messages="errors.short_or_excess_shipment_percent" variant="outlined" density="compact"/>
                    </v-col>

                    <v-col cols="12" md="4">
                       <v-text-field  autocomplete="on" label="Payment Terms" v-model="payment_terms" :error-messages="errors.payment_terms" variant="outlined" density="compact"/>
                    </v-col>

                    <v-col cols="12" md="2">

                      <v-autocomplete
                        label="Partial Shipment*"
                        v-model="partial_shipment"
                        :items="[
                            { label: 'Allowed', value: 'allowed' },
                            { label: 'Not Allowed', value: 'not_allowed' }
                        ]"
                        item-title="label"
                        item-value="value"
                        :error-messages="errors.partial_shipment"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-autocomplete
                        label="Early Shipment*"
                        v-model="early_shipment"
                        :items="[
                            { label: 'Allowed', value: 'allowed' },
                            { label: 'Not Allowed', value: 'not_allowed' }
                        ]"
                        item-title="label"
                        item-value="value"
                        :error-messages="errors.early_shipment"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="2">
                      <v-autocomplete
                        label="Transhipment*"
                        v-model="transhipment"
                        :items="[
                            { label: 'Allowed', value: 'allowed' },
                            { label: 'Not Allowed', value: 'not_allowed' }
                        ]"
                        item-title="label"
                        item-value="value"
                        :error-messages="errors.transhipment"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12">
                      <v-textarea label="Terms & Condition"
                        v-model="terms_and_condition"
                        rows="2" variant="outlined" density="compact"/>
                    </v-col>

                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <!-- RIGHT : DYEING BREAKDOWN -->
          <v-col cols="12" md="12">
            <v-expansion-panels v-model="panel1" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-header" color="blue-grey-lighten-4">
                  Proforma Invoice Details
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <v-card flat>
                    <v-card-text style="overflow-y: auto; white-space: nowrap;">

                        <table class="dep-table order-table mt-4 custome-table">
                            <thead>
                                <tr>
                                    <th class="table-header-cel" v-for="col in headers" :key="col.value">{{ col.text }}</th>
                                    <th class="table-header-cel">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(row, rowIndex) in tableData" :key="row.id" :class="{ 'error-row': tableErrors[rowIndex] }">
                                    <td v-for="(col, colIndex) in headers" :key="col.value" :class="{ 'error-td': (tableErrors[rowIndex]?.[col.value]) }">
                                         <v-text-field  
                                            autocomplete="on"
                                            style="min-width:150px;"
                                            v-if="!['cargo_receiving_date','etd_date','currency','quantity','unit_price','total_amount','destination'].includes(col.value)"
                                            class="breakdown-input"
                                            v-model="row[col.value]"
                                            dense
                                            hide-details
                                            variant="outlined"
                                            :error-messages="tableErrors[rowIndex]?.[col.value]"
                                            @keydown.enter.prevent="focusNextCell(rowIndex, colIndex)"
                                            @keydown.tab.prevent="focusNextCell(rowIndex, colIndex)"
                                        />

                                         <v-text-field  
                                            autocomplete="on"
                                            style="min-width:150px;"
                                            v-if="['destination'].includes(col.value)"
                                            class="breakdown-input"
                                            v-model="row[col.value]"
                                            dense
                                            hide-details
                                            variant="outlined"
                                            @keydown.enter.prevent="focusNextCell(rowIndex, colIndex)"
                                            @keydown.tab.prevent="focusNextCell(rowIndex, colIndex)"
                                        />

                                           <v-text-field  
                                            autocomplete="on"
                                            type="number"
                                            style="min-width:100px;"
                                            v-if="['quantity','unit_price'].includes(col.value)"
                                            class="breakdown-input"
                                            v-model="row[col.value]"
                                            dense
                                            hide-details
                                            variant="outlined"
                                            @update:model-value="calculateTotalValue(rowIndex)"
                                            :error-messages="tableErrors[rowIndex]?.[col.value]"
                                            @keydown.enter.prevent="focusNextCell(rowIndex, colIndex)"
                                            @keydown.tab.prevent="focusNextCell(rowIndex, colIndex)"
                                        />

                                         <v-text-field  
                                            autocomplete="on"
                                            type="number"
                                            style="min-width:100px;"
                                            v-if="['total_amount'].includes(col.value)"
                                            class="breakdown-input"
                                            v-model="row[col.value]"
                                            dense
                                            hide-details
                                            variant="outlined"
                                            :error-messages="tableErrors[rowIndex]?.[col.value]"
                                            @keydown.enter.prevent="focusNextCell(rowIndex, colIndex)"
                                            @keydown.tab.prevent="focusNextCell(rowIndex, colIndex)"
                                            readonly=""
                                        />

                                        <v-autocomplete
                                            style="height: 32px !important; min-width:150px;"
                                            v-if="['currency'].includes(col.value)"
                                            class="breakdown-input"
                                            v-model="row[col.value]"
                                            :items="currencyList"
                                            :item-title="item => `${item.code} - ${item.name}`"
                                            item-value="id"
                                            density="compact"
                                            variant="outlined"
                                        />

                                        <v-date-input
                                            input-format="dd/mm/yyyy"

                                            style="height:30px !important; min-width:150px;"
                                            v-if="['cargo_receiving_date','etd_date'].includes(col.value)"
                                            class="breakdown-input"
                                            v-model="row[col.value]"
                                            variant="outlined"
                                            density="compact"
                                            prepend-icon=""
                                            @keydown.enter.prevent="focusNextCell(rowIndex, colIndex)"
                                            @keydown.tab.prevent="focusNextCell(rowIndex, colIndex)"
                                            clearable
                                        />
                                    </td>
                                    <td style="width:65px;">
                                        <v-btn v-if=" (rowIndex != tableData.length - 1) || (tableData.length > 1)" icon variant="tonal" size="small" color="primary" class="pa-1 breakdown-input" @click="removeRow(rowIndex)">
                                            <v-icon color="red">mdi-close</v-icon>
                                        </v-btn>

                                        <v-btn v-if="rowIndex == tableData.length - 1" variant="tonal" icon size="small" color="primary" class=" breakdown-input" @click="addRow">
                                            <v-icon color="blue">mdi-plus</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-card-text>

                    <v-card-actions class="justify-end">
                      <v-btn class="bg-grey-darken-1 me-2" @click="submitForm(0)">Draft</v-btn>
                      <v-btn class="bg-primary" @click="submitForm(1)">
                        {{ isEdit ? 'Update' : 'Save' }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

        </v-row>
      </v-form>
    </v-container>
  </v-app>
</template>

<script setup>
    import { ref, reactive, nextTick, onMounted, computed } from "vue";
    import { useRoute, useRouter } from "vue-router";
    import { toast } from "vue3-toastify";
    import { useStore } from "vuex";
    import * as yup from "yup";
    import formattedDate from "@/plugins/dateFormatter";

    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const updateId = route.params.id;

    const headers = [
        { text: "PO Number", value: "po" },
        { text: "Style Number", value: "style_number" },
        { text: "Description", value: "description" },
        { text: "HS Code", value: "hs_code" },
        { text: "Composition", value: "composition" },
        { text: "Color Name", value: "color_name" },
        { text: "Size Range", value: "size_range" },
        { text: "Quantity", value: "quantity" },
        { text: "Unit Price", value: "unit_price" },
        { text: "Total Amount", value: "total_amount" },
        { text: "Currency", value: "currency" },
        { text: "Cargo Receiving Date", value: "cargo_receiving_date" },
        { text: "ETD Date", value: "etd_date" },
        { text: "Destination", value: "destination" },
    ];

    const panel = ref([0]);
    const panel1 = ref([0]);
    const isEdit = ref(false);

    const invoice_date = ref(null);
    const master_sales_contact_id = ref(null);
    const proforma_invoice_no = ref("");
    const season = ref("");
    const department = ref("");
    const purchase_order_no = ref("");
    const master_sales_contact_no = ref("");
    const buyer_id = ref(null);
    const beneficiary_bank_id = ref(null);
    const currency_id = ref(null);
    // const buyer_bank_id = ref(null);
    const shipment_from = ref("");
    const shipment_to = ref("");
    const shipment_mode_id = ref(null);
    const inspaction_certificate_by = ref("");
    const lc_expiry_date = ref(null);
    const port_of_destination_id = ref(null);
    const incoterm = ref("");
    const short_or_excess_shipment_percent = ref("");
    const port_of_loading_id = ref(null);
    const payment_terms = ref("");
    const partial_shipment = ref(null);
    const early_shipment = ref(null);
    const transhipment = ref(null);
    const terms_and_condition = ref("");

    const tableData = reactive([]);
    const errors = reactive({});
    const tableErrors = reactive({});

    const masterSalesContactList = ref([]);
    const loading = ref(false);
    const selected_master_sales  = ref(null);

    const portList = computed(() => store.getters.getLcPortList || []);
    const buyerList =  computed(() => store.getters.getCustomerList || []);
    const currencyList =  computed(() => store.getters.getCurrencyList || []);
    const bankList =  computed(() => store.getters.getLcBankList || []);
    const shippingMethodList =  computed(() => store.getters.getLcShippingMethodList || []);


    async function getInitialData() {
      tableData.length = 0;
      store.commit("SET_LOADING", { color: "primary" });
      loading.value = true;
      const updateData = updateId ? await store.dispatch("getProformaInvoiceById", { id: updateId }) : null;
      let masterSalesContactListRes = await store.dispatch("getMasterSalesContactList");
      if (store.getters.getCustomerList.length === 0) { await store.dispatch("getCustomerList");}
      if (store.getters.getLcBankList.length === 0) { await store.dispatch("getLcBankList");}
      if (store.getters.getCurrencyList.length === 0) { await store.dispatch("getCurrencyList");}
      if (store.getters.getLcShippingMethodList.length === 0) { await store.dispatch("getLcShippingMethodList");}
      if (store.getters.getLcPortList.length === 0) { await store.dispatch("getLcPortList");}
      store.commit("UNSET_LOADING");
      masterSalesContactList.value   = masterSalesContactListRes.data.data;


      if (updateId && updateData?.data?.data) {
        isEdit.value = true;
        const data = updateData.data.data;

        invoice_date.value = data.invoice_date ? new Date(data.invoice_date) : null;
        master_sales_contact_id.value = data.master_sales_contact_id ?? null;
        proforma_invoice_no.value = data.proforma_invoice_no || "";
        season.value = data.season || "";
        department.value = data.department || "";
        purchase_order_no.value = data.purchase_order_no || "";
        master_sales_contact_no.value = data.master_sales_contact_no || "";
        buyer_id.value = data.buyer_id || null;
        beneficiary_bank_id.value = data.beneficiary_bank_id || null;
        currency_id.value = data.currency_id || null;
        // buyer_bank_id.value = data.buyer_bank_id || null;
        shipment_from.value = data.shipment_from || "";
        shipment_to.value = data.shipment_to || "";
        shipment_mode_id.value = data.shipment_mode_id || null;
        inspaction_certificate_by.value = data.inspaction_certificate_by || "";
        lc_expiry_date.value = data.lc_expiry_date ? new Date(data.lc_expiry_date) : null;
        port_of_destination_id.value = data.port_of_destination_id || "";
        port_of_loading_id.value = data.port_of_loading_id || "";
        incoterm.value = data.incoterm || "";
        short_or_excess_shipment_percent.value = data.short_or_excess_shipment_percent || "";
        payment_terms.value = data.payment_terms || "";
        partial_shipment.value = data.partial_shipment || null;
        early_shipment.value = data.early_shipment || null;
        transhipment.value = data.transhipment || null;
        terms_and_condition.value = data.terms_and_condition || "";

        if (data.breakdowns?.length) {
          tableData.splice(
            0,
            tableData.length,
            ...data.breakdowns.map((row, index) => ({
              id: index + 1,
              po: row.po || "",
              master_sales_contact_details_id:row.id,
              style_number: row.style_number || "",
              description: row.description || "",
              hs_code: row.hs_code || "",
              composition: row.composition || "",
              color_name: row.color_name || "",
              size_range: row.size_range || "",
              quantity: row.quantity || 0,
              unit_price: row.unit_price || 0,
              total_amount: row.total_amount || 0,
              currency: row.currency_id || null,
              cargo_receiving_date: row.cargo_receiving_date ? new Date(row.cargo_receiving_date) : null,
              etd_date: row.etd_date ? new Date(row.etd_date) : null,
              destination: row.destination || "",
            }))
          );
        } 

      } 
      else{
        addRow();
      }
    }

    function changeMsterSalesContact(id){
      const selected = masterSalesContactList.value.find(
        item => item.id === id
      );
      selected_master_sales.value = selected; 

      buyer_id.value = selected?.buyer_id;
      master_sales_contact_no.value = selected.contact_no;

      if (!selected?.details || !selected.details.length) return;

      tableData.length = 0;

      selected.details.forEach(item => {
        const row = {
          id: item.id, 
          master_sales_contact_details_id: item.id ?? null,
          po: item.po ?? "",
          style_number: item.style_no ?? "",
          description: item.description ?? "",
          hs_code: item.hs_code ?? "",
          composition: item.composition ?? "",
          color_name: item.color_name ?? "",
          size_range: item.size_range ?? "",
          quantity: item.quantity ?? 0,
          unit_price: item.unit_price ?? 0,
          total_amount: item.total_amount ?? 0,
          currency: item.currency_id ?? null,
          cargo_receive_date: item.ex_factory_date ?? null,
          etd_date: item.etd_date ?? null,
          destination: item.destination ?? "",
        };
        tableData.push(row);
      });
    }

    function calculateTotalValue(rowIndex){
      tableData[rowIndex].total_amount = tableData[rowIndex].unit_price * tableData[rowIndex].quantity;
    }

    function addRow() {
      const newId = tableData.length ? tableData[tableData.length - 1].id + 1 : 1;
      const row = { id: newId,master_sales_contact_details_id:null };
      headers.forEach(h => (row[h.value] = ""));
      tableData.push(row);
      nextTick(() => focusCell(tableData.length - 1, 0));
    }

    function removeRow(index){
      if (tableData.length > 1) {
          tableData.splice(index, 1);
      }

      const newErrors = {};
      tableData.forEach((_, i) => {
          if (tableErrors[i]) {
            newErrors[i] = tableErrors[i];
          }
      });

      Object.keys(tableErrors).forEach(k => delete tableErrors[k]);
      Object.assign(tableErrors, newErrors);
    }

    function focusNextCell(rowIndex, colIndex) {
      const totalRows = tableData.length;
      const totalCols = headers.length;
      let nextRow = rowIndex;
      let nextCol = colIndex + 1;

      if (nextCol >= totalCols) {
          nextCol = 0;
          nextRow++;
          if (nextRow >= totalRows) {
              addRow();
              nextRow = totalRows;
          }
      }
      focusCell(nextRow, nextCol);
    }

    function focusCell(rowIndex, colIndex) {
      nextTick(() => {
          const table = document.querySelector("table");
          const row = table?.rows[rowIndex + 1];
          if (row) {
            const cell = row.cells[colIndex]?.querySelector("input");
            if (cell) cell.focus();
          }
      });
    }

    const breakdownSchema = yup.object({
      po: yup.string().required("PO Number required"),
      style_number: yup.string().required("Style Number required"),
      description: yup.string().required("Description required"),
      hs_code: yup.string().required("HS Code required"),
      composition: yup.string().required("Composition required"),
      color_name: yup.string().required("Color Name required"),
      size_range: yup.string().required("Size Range required"),
      quantity: yup.number().typeError("Quantity must be number").required("Quantity required").positive(),
      unit_price: yup.number().typeError("Unit Price must be number").required("Unit Price required").min(0),
      total_amount: yup.number().typeError("Total Amount must be number").required("Total Amount required"),
      currency: yup.number().required("Currency required"),
      //cargo_receiving_date: yup.date().nullable().required("Cargo Receiving Date required"),
      //etd_date: yup.date().nullable().required("ETD Date required"),
      //destination: yup.string().required("Destination required"),
    });


    const schema = yup.object({
      invoice_date: yup.date().required("Invoice date required"),
      // master_sales_contact_id: yup.number().required("Master Sales Contact"),
      proforma_invoice_no: yup.string().required("Proforma invoice no required"),
      buyer_id: yup.number().required("Buyer required"),
      beneficiary_bank_id: yup.number().required("Beneficiary bank required"),

      port_of_destination_id: yup.number().required("Port of Destination"),
      port_of_loading_id: yup.number().required("Port of Loading"),
      // buyer_bank_id: yup.number().required("Buyer bank required"),
      shipment_from: yup.string().required("Shipment from required"),
      shipment_to: yup.string().required("Shipment to required"),
      shipment_mode_id: yup.number().required("Shipment mode required"),
      lc_expiry_date: yup.date().nullable().required("LC expiry date required"),
      incoterm: yup.string().required("Incoterm required"),
      payment_terms: yup.string().required("Payment terms required"),
      partial_shipment: yup.string().required("Partial shipment required"),
      early_shipment: yup.string().required("Early shipment required"),
      transhipment: yup.string().required("Transhipment required"),
      breakdowns: yup.array().of(breakdownSchema).min(1, "At least one breakdown row required"),
    });


    async function submitForm(status) {
    
        Object.keys(errors).forEach(k => delete errors[k]);
        Object.keys(tableErrors).forEach(k => delete tableErrors[k]);

        const formattedTableData = tableData.map(row => ({
          ...row,
          cargo_receiving_date: row.cargo_receiving_date
            ? formattedDate(row.cargo_receiving_date)
            : null,
          etd_date: row.etd_date
            ? formattedDate(row.etd_date)
            : null,
        }));

        tableData.splice(0, tableData.length, ...formattedTableData);

        const payload = {
          invoice_date: formattedDate(invoice_date.value),
          master_sales_contact_id:master_sales_contact_id.value,
          proforma_invoice_no: proforma_invoice_no.value,
          season: season.value,
          department: department.value,
          purchase_order_no: purchase_order_no.value,
          master_sales_contact_no: master_sales_contact_no.value,
          buyer_id: buyer_id.value,
          beneficiary_bank_id: beneficiary_bank_id.value,
          currency_id: currency_id.value,
          // buyer_bank_id: buyer_bank_id.value,
          shipment_from: shipment_from.value,
          shipment_mode_id: shipment_mode_id.value,
          inspaction_certificate_by: inspaction_certificate_by.value,
          lc_expiry_date: formattedDate(lc_expiry_date.value),
          port_of_destination_id: port_of_destination_id.value,
          shipment_to: shipment_to.value,
          incoterm: incoterm.value,
          short_or_excess_shipment_percent: short_or_excess_shipment_percent.value,
          port_of_loading_id: port_of_loading_id.value,
          payment_terms: payment_terms.value,
          partial_shipment: partial_shipment.value,
          early_shipment: early_shipment.value,
          transhipment: transhipment.value,
          terms_and_condition: terms_and_condition.value,
          status:status,
          breakdowns: tableData,
        };

        try {
            await schema.validate(payload, { abortEarly: false });
            if(isEdit.value) {
                await store.dispatch("updateProformaInvoice", { id: updateId, data: payload }).then((res) => {
                    if(!res.data.success){
                        toast.error(res.data.message);
                    }else{
                        toast.success("Saved Successfully");
                        router.push({ name: "proforma-invoice-record" });
                    }
                 });
                toast.success("Updated Successfully");
            } else {
                await store.dispatch("saveProformaInvoice", payload).then((res) => {
                    if(!res.data.success){
                        toast.error(res.data.message);
                    }else{
                        toast.success("Saved Successfully");
                        router.push({ name: "proforma-invoice-record" });
                    }
                 });
            }
        } catch(err) {
          if (err.inner && err.inner.length) {
              err.inner.forEach(e => {
                  if (e.path && e.path.startsWith("breakdowns")) {
                      const match = e.path.match(/breakdowns\[(\d+)\]\.(.+)/);
                      if (match) {
                          const rowIndex = match[1];
                          const field = match[2];

                          if (!tableErrors[rowIndex]) tableErrors[rowIndex] = {};
                          tableErrors[rowIndex][field] = e.message;
                      }
                  } else {
                      errors[e.path] = e.message;
                  }
              });
          } else if (err.path) {
              // Single error handle
              errors[err.path] = err.message;
          }
        }
    }

    onMounted(getInitialData);
</script>

<style>
.panel-header {
  background: #eceff1;
  font-weight: 600;
}

.breakdown-input .v-input {
  min-height: 32px !important;
  height: 32px !important;
  border:none !important;
  border-radius: 0px !important;
}

.breakdown-input .v-field {
  min-height: 32px !important;
  height: 32px !important;
  border:none !important;
  border-radius: 0px !important;
}

.breakdown-input .v-field .v-field__input {
  min-height: 32px !important; 
  height: 32px !important;
  padding: 2 !important;
  font-size: 12px;
}

.breakdown-input input{
    min-height: 32px !important; 
  height: 32px !important;
  max-height: 32px !important;
}


.custome-table {
    width: 100% !important;
    border-collapse: collapse;
}

.custome-table th,
.custome-table td {
    border: 1px solid #c0c0c0;
    text-align: left; 
}

.custome-table th {
    background-color: #eceff1; 
    font-weight: 600;
}
.table-header-cel{
    text-align: center !important;
    height: 30px;
    font-size: 12px;
}

.v-btn--icon{
  height: 30px !important;
  width: 30px !important;
}
.error-row {
  /* background: #fff3f3; */
}
.error-td{
  border-color: red !important;
}

</style>
